<div #container
    *ngIf="show === true && canShow === true"
    class="float-dialog rift-multi-unit-alignment-device-list"
    (click)="onMenuClick()"
    ngResizable
    #resizable="ngResizable"
    (rzStop)="onRzStop($event)"
    (rzStart)="onRzStart($event)"
    (rzResizing)="onRzResizing($event)"
    [rzMinHeight]="minHeight"
    [rzMinWidth]="minWidth"
    [rzMinWidth]="minWidth"
    [rzMinHeight]="minHeight"
    [rzMaxWidth]="maxWidth"
    [rzMaxHeight]="maxHeight"
    ngDraggable
    #draggable="ngDraggable"
    (started)="onDrStarted($event)"
    (stopped)="onDrStopped($event)"
    (edge)="onDrEdge($event)"
    (movingOffset)="onDrMovingOffset($event)"
    (endOffset)="onDrEndOffset($event)"
    [handle]="title"
    [bounds]="bounds"
    [position]="position"
    [inBounds]="!isNullOrUndefined(bounds)">
    <div #title
        class="title drag-handle"
        fxLayout="row"
        fxLayoutAlign="start center">
        <div fxFlex
            fxLayout="row"
            fxLayoutAlign="start center">
            <div fxLayout="column">
                <div class="header">
                    Alignment
                </div>
            </div>
            <div fxFlex></div>
        </div>
    </div>
    <div class="content"
        fxLayout="column">
        <div fxLayout="row" fxFlex>
            <button mat-raised-button class="actionButtons" (click)="onSave()">
                Save
            </button>
            <div fxFlex></div>
            <button mat-raised-button class="actionButtons" (click)="onExit()">
                Exit
            </button>
        </div>
        <div #deviceList
            class="device-list"
            [ngStyle]="{'height': devicesListHeight + 'px'}">
            <div *ngFor="let vm of devices"
                class="device"
                fxLayout="row"
                fxLayoutAlign="start center"
                (click)="onDeviceSelected(vm)">
                <div fxLayout="column">
                    <div class="header"
                        fxLayout="row"
                        fxLayoutAlign="start center">
                        <div class="value">
                            {{ vm.deviceModel.serialNumber }} ({{ vm.deviceModel.master ? 'Master' : 'Node' }})
                        </div>
                    </div>
                    <div fxLayout="column">
                        <div [hidden]="vm.video.visible === false">
                            <mat-slider min="0.25" max="1" step="0.05" value="1" (change)="onAlphaSliderChange(vm, $event)" #alphaSlider></mat-slider>
                        </div>
                        <div fxLayout="row" *ngIf="vm.video.visible === true">
                            <mat-form-field class="position-values">
                                <mat-label>
                                    X:
                                </mat-label>
                                <input type="number" matInput [value]="vm.deviceModel.x" step="1" (change)="onXPosChange(vm, $event)">
                            </mat-form-field>
                            <mat-form-field class="position-values">
                                <mat-label>
                                    Y:
                                </mat-label>
                                <input type="number" matInput [value]="vm.deviceModel.y" step="1" (change)="onYPosChange(vm, $event)">
                            </mat-form-field>
                            <mat-form-field class="position-values">
                                <mat-label>
                                    Yaw:
                                </mat-label>
                                <input type="number" matInput [value]="radToDegree(vm.deviceModel.gVector.yaw)" step="0.1" min="-0.1" max="360" (change)="onYawChange(vm, $event)">
                                <span matSuffix>&#176;</span>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div fxFlex></div>
                <div class="actions">
                    <button
                        (click)="onShowHideDeviceClick(vm, $event, alphaSlider)"
                        class="flat-icon-button"
                        mat-stroked-button
                        [matTooltip]="vm.video.visible === true ? 'Hide device' : 'Show device'">
                        <shr-fa [name]="vm.video.visible === true ? 'eye' : 'eye-slash'"></shr-fa>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>